import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#111111]/95 backdrop-blur-sm border-b border-[#f5a623]/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <button
          onClick={() => scrollTo('hero')}
          className="flex items-center gap-3 group cursor-pointer"
          aria-label="Home"
        >
          <div className="w-9 h-9 flex items-center justify-center bg-[#f5a623] rounded-md group-hover:bg-[#d4722e] transition-colors duration-200">
            <i className="ri-tools-fill text-black text-lg" />
          </div>
          <span className="text-white font-['Bebas_Neue'] text-xl tracking-widest group-hover:text-[#f5a623] transition-colors whitespace-nowrap">
            BEER AFTER WORK
          </span>
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'LATEST FIX', id: 'latest-biscuit' },
            { label: 'THE SHOP', id: 'shop' },
            { label: 'TOOL BENCH', id: 'tool-bench' },
            { label: 'BEER MAP', id: 'beer-map' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-[#b8b8b8] text-xs font-['Roboto'] font-bold tracking-[2px] hover:text-[#f5a623] transition-colors duration-200 relative group cursor-pointer whitespace-nowrap"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#f5a623] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </div>

        {/* Subscribe Button */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="https://www.youtube.com/@beerafterwork"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 border border-[#f5a623] text-white text-xs font-bold tracking-[1.5px] px-4 py-2 rounded-md hover:bg-[#f5a623] transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-youtube-fill text-sm" />
            SUBSCRIBE
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#111111]/98 border-t border-[#f5a623]/20 px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'LATEST FIX', id: 'latest-biscuit' },
            { label: 'THE SHOP', id: 'shop' },
            { label: 'TOOL BENCH', id: 'tool-bench' },
            { label: 'BEER MAP', id: 'beer-map' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-[#b8b8b8] text-sm font-bold tracking-[2px] text-left hover:text-[#f5a623] transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://www.youtube.com/@beerafterwork"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="border border-[#f5a623] text-white text-xs font-bold tracking-[1.5px] px-4 py-2 rounded-md text-center hover:bg-[#f5a623] transition-all whitespace-nowrap"
          >
            SUBSCRIBE ON YOUTUBE
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
